var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-fill"},[_c('h3',{staticClass:"mg-t-30 text-align-center"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }